import React, { useEffect } from "react";
import useTypeDecription from "../../../hooks/useTypeDecription";
import LinkQrWrapper from "../linkPage/LinkQrWrapper";
import AmazonIcon from "./svg/AmazonIcon";
import { useSelector } from "react-redux";
import { AttendanceIcon } from "../../FirstScreen/cardTypeQr/svg";

export default function AmazonPage() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepTwo.attendance
  );
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("attendance");
  }, []);

  return (
    <LinkQrWrapper
      prefixIcon={<AttendanceIcon />}
      fieldPlaceholder={lang[0]}
      popoverText={lang[1]}
    >
      {content}
    </LinkQrWrapper>
  );
}
